import React, { useContext,useEffect } from 'react';
import { Box, Text, Modal, ModalOverlay, ModalContent, ModalBody, ModalFooter, ModalCloseButton, Button, useDisclosure } from '@chakra-ui/react';
import { RefreshContext } from '../../utils/refreshContext';
import { useSelector, useDispatch } from 'react-redux';
import { fetchJobList } from '../../store/slices/jobListSlice';
import ViewJob from './viewJob';
const JobList = ({ onViewJob }) => {
  const dispatch = useDispatch();

  const { jobs, loading, error } = useSelector(state => state.jobList);
  const { isOpen, onClose } = useDisclosure();
  const { refreshJobs } = useContext(RefreshContext);
  useEffect(() => {
    dispatch(fetchJobList());
  }, [dispatch,refreshJobs]);

  const handleViewJob = (jobId) => {
    onViewJob(jobId); // Set the selected job in ProviderHome
  };

  if (loading) {
    return <p>Loading...</p>;
  }

  if (error) {
    return <p>Error: {error}</p>;
  }
 
  // const jobs = [
  //   { title: 'Medical Supervisor', status: 'Hired' },
  //   { title: 'Healthcare Assistant', status: 'Pending' },
  //   { title: 'Nursing Assistant', status: 'Pending' },
  //   { title: 'Doctor Assistant', status: 'Hired' },
  //   { title: 'Lab Technician', status: 'Pending' },
  //   { title: 'Physician', status: 'Hired' },
  //   { title: 'Therapist', status: 'Pending' },
  //   { title: 'Medical Receptionist', status: 'Hired' },
  //   { title: 'Pharmacist', status: 'Pending' },
  //   { title: 'Radiologist', status: 'Hired' },
  //   { title: 'Surgeon', status: 'Pending' },
  // ];

  // const handleClick = (index) => {
  //   setClickedJob(index);
  //   setTimeout(() => setClickedJob(null), 500); // Reset after animation
  // };

  return (
    <Box bg="white"  p={{ base: 4, md: 6 }} borderRadius="md" maxW="1200px" mx="auto" w="100%"> {/* Light grey background */}
      {/* Scrollable Container */}
      <Box
      width="100%"
        maxH="262px"  // Set the maximum height of the scrollable container
        overflowY="auto"  // Enable vertical scrolling
        p={{ base: 2, md: 4 }}
        borderRadius="md"
        css={{
          '&::-webkit-scrollbar': {
            display: 'none',  // Hides the scrollbar for webkit browsers (Chrome, Safari, etc.)
          },
          '-ms-overflow-style': 'none',  // Hides the scrollbar for IE and Edge
          'scrollbar-width': 'none',  // Hides the scrollbar for Firefox
        }}
      >
        {jobs.map((job, index) => (
          <Box
            key={index}
            bg="blue.500"  // Changed to Chakra UI's blue.500
            borderRadius="md"
            p={4}
            mb={6}
            boxShadow="md"
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            cursor="pointer"  // Add pointer cursor to indicate clickable items
            transform={  index ? 'translateY(-10px)' : 'translateY(0)'}  // Jumping effect
            transition="transform 0.2s ease"  // Smooth transition for jumping
            onClick={() => handleViewJob(job._id)}  // Handle click event
            flexDirection={{ base: 'column', md: 'row' }} // Column layout for mobile, row for desktop
          >
            <Text fontSize={{ base: 'md', md: 'lg' }} fontWeight="bold" color="white"  mb={{ base: 2, md: 0 }}> {/* White text for job title */}
              {job.jobTitle}
            </Text>

            <Box
              bg="white"  // White background for the status box
              borderRadius="md"
              p={2}
              minW="100px"
              textAlign="center"
              boxShadow="sm"
            >
              <Text fontSize={{ base: 'xs', md: 'sm' }} fontWeight="bold" color="gray.500">
                {job.status}
              </Text>
            </Box>
          </Box>
        ))}
      </Box>
        {/* Popup Modal */}
        <Modal isOpen={isOpen} onClose={onClose}  size={{ base: 'full', sm: 'md', md: 'lg', lg: 'xl' }}   scrollBehavior="inside" isCentered>
        <ModalOverlay backdropFilter="blur(10px)" />
        <ModalContent maxW={{ base: '100%', md: '80%', lg: '70%' }} h={{ base: '80vh', md: '90vh', lg: '95vh' }} maxH="95vh">
          <ModalCloseButton color="blue.500" _hover={{ bg: 'blue.500', color: 'white' }}/>
          <ModalBody >
            <ViewJob onBack={onClose} refreshJobs={refreshJobs} />
          </ModalBody>
         
        </ModalContent>
      </Modal>
    </Box>
  );
};

export default JobList;